var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xlsxWrapper",attrs:{"id":"excel-wrapper"}},_vm._l((_vm.tables),function(html,i){return _c('span',{key:i,domProps:{"innerHTML":_vm._s(html)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }